import { render, staticRenderFns } from "./PriceSetDialog.vue?vue&type=template&id=0794728d"
import script from "./PriceSetDialog.vue?vue&type=script&lang=js"
export * from "./PriceSetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports